import useSWR from 'swr';
import api from './api';

export function useStressById(id) {
  const { data, error, isLoading, mutate } = useSWR(
    id ? `/stress/${id}` : null,
    async (url) => {
      const response = await api.get(url);
      const resData = response?.data;
      return Array.isArray(resData) ? resData[0] : resData;
    },
    {
      // Opcional: evita que o SWR fique tentando 3x se o ID não existe
      shouldRetryOnError: (err) => {
        if (err.response?.status === 404) return false;
        return true;
      },
      onError: (err) => {
        console.warn(`Erro na busca do ID ${id}:`, err.response?.status || err.message);
      },
    }
  );

  return {
    data,
    error,
    isLoading,
    isNotFound: error?.response?.status === 404,
    mutate,
  };
}

export const updateStress = async (id, data) => {
  const response = await api.put(`stress/${id}`, data);
  return response.data;
};
